module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Editorial Board"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'editorialBoardMembers'
        })
      }
    }
  }, [_vm._v("Editorial Board Members")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'hundredPlus'
        })
      }
    }
  }, [_vm._v("100+ Papers from Editorial Board")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f7ff282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-nav/dropdowns/EditorialBoardDropdownComponent.vue
// module id = 1422
// module chunks = 1